import { render } from "./SystemLegalVersionEditor.vue?vue&type=template&id=0ac8f9c4&scoped=true"
import script from "./SystemLegalVersionEditor.vue?vue&type=script&lang=js"
export * from "./SystemLegalVersionEditor.vue?vue&type=script&lang=js"

import "./SystemLegalVersionEditor.vue?vue&type=style&index=0&id=0ac8f9c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ac8f9c4"]])

export default __exports__